import { create } from "zustand";

type ProjectTreeSelectionState = {
  /** Project id that owns the current selection payload. */
  projectId: string | null;
  /** Sidebar tree node ids currently multi-selected (documents and/or folders). */
  selectedNodeIds: string[];
  setSelectedNodeIds: (ids: string[], projectId?: string | null) => void;
  clearSelectedNodeIds: (projectId?: string | null) => void;
};

export const useProjectTreeSelectionStore = create<ProjectTreeSelectionState>((set) => ({
  projectId: null,
  selectedNodeIds: [],
  setSelectedNodeIds: (ids, projectId = null) => set({ selectedNodeIds: ids, projectId }),
  clearSelectedNodeIds: (projectId = null) =>
    set((state) => (state.selectedNodeIds.length === 0 && state.projectId === projectId ? state : { selectedNodeIds: [], projectId })),
}));
